import API from '@repositories/Axios';
import type { Page } from '@type/Page';
import { injectable } from 'inversify';
import qs from 'qs';
import type ICommonCodeRepository from '../ICommonCodeRepository';
import type { CommonCode, CommonCodeCreateRq, CommonCodeFilter, CommonCodeUpdateRq } from '../commonCode.types';

@injectable()
export class CommonCodeRepository implements ICommonCodeRepository {
  async create(data: CommonCodeCreateRq): Promise<CommonCode> {
    const result = await API.post<CommonCode>('/api/v1/common-codes', data);
    return result.data;
  }
  async getOne(id: string): Promise<CommonCode> {
    const result = await API.get<CommonCode>(`/api/v1/common-codes/${id}`);
    return result.data;
  }
  async getList(filter: CommonCodeFilter): Promise<Page<CommonCode>> {
    const queryString = qs.stringify(filter, { skipNulls: true });
    const result = await API.get<Page<CommonCode>>(`/api/v1/common-codes?${queryString}`);
    return result.data;
  }
  async update(id: string, data: CommonCodeUpdateRq): Promise<CommonCode> {
    const result = await API.put<CommonCode>(`/api/v1/common-codes/${id}`, data);
    return result.data;
  }
  async delete(id: string): Promise<void> {
    await API.delete(`/api/v1/common-codes/${id}`);
  }
}
